import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { 
	NoPlanImage
} from 'assets/img';
import { ConsultationPlanService } from 'services';
import { Modal, DatePicker } from 'components';
import moment from 'moment';
import { TimeIcon, FacebookIcon, InstagramIcon, WhatsappIcon, ApiIcon, MessageIcon, Menu as MenuIcons, TiktokIcon } from 'assets/icons';
import { Table, Select } from 'components';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ModalSelectPlan from 'screens/admin/users/select-consultation-plan';
import { 
	Chart, 
	BarController,
	BarElement,
	LinearScale,
	CategoryScale,
} from 'chart.js';

Chart.register(
	BarController,
	BarElement,
	LinearScale,
	CategoryScale,
	ChartDataLabels
);

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Home extends React.Component<Props> {

	state = {
		plan_users: [],
		loading: true,
		chart_left: null,
		chart_left_labels: [],
		chart_left_data: [],
		chart_right: null,
		chart_right_labels: [],
		chart_right_data: [],
		total_conversations: 0,
		uses_consultations: 0,
		max_consultations: 0,
		ways: [],
		visible_modal: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Inicio',
				onBack: null,
				hide: true
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		// @ts-ignore
		this.state.chart_left?.destroy();

		// @ts-ignore
		this.state.chart_right?.destroy();

		const res: any = await ConsultationPlanService.get({
			withoutLoading
		});

		let ways: any = [...this.state.ways];
		if (res.facebook_quantity != null) {
			ways.push({
				icon: FacebookIcon,
				backgroundColor: Colors.facebook,
				quantity: res.facebook_quantity
			});
		}
		if (res.instagram_quantity != null) {
			ways.push({
				icon: InstagramIcon,
				backgroundColor: Colors.instagram,
				quantity: res.instagram_quantity
			});
		}
		if (res.whatsapp_quantity != null) {
			ways.push({
				icon: WhatsappIcon,
				backgroundColor: Colors.whatsapp,
				quantity: res.whatsapp_quantity
			});
		}
		if (res.api_quantity != null) {
			ways.push({
				icon: ApiIcon,
				backgroundColor: Colors.api,
				quantity: res.api_quantity
			});
		}
		if (res.tiktok_quantity != null) {
			ways.push({
				icon: TiktokIcon,
				barColor: Colors.tiktok,
				backgroundColor: Colors.black,
				quantity: res.tiktok_quantity
			});
		}

		this.setState({
			plan_users: res.plan_users || [],
			loading: false,
			chart_left_labels: res.chart_left_labels || [],
			chart_left_data: res.chart_left_data || [],
			chart_right_labels: res.chart_right_labels || [],
			chart_right_data: res.chart_right_data || [],
			total_conversations: res.total_conversations || 0,
			uses_consultations: res.uses_consultations,
			max_consultations: res.max_consultations,
			ways
		},() => {
			try {
				this.setState({
					// @ts-ignore
					chart_left: new Chart(document.getElementById("chart-left"), {
						type: 'bar',
						data: {
						  labels: this.state.chart_left_labels || [],
						  datasets: [{
					        label: 'Conversaciones',
					        data: this.state.chart_left_data || [],
					        borderColor: Colors.chartAccepted,
					        backgroundColor: Colors.chartAccepted,
					        borderRadius: {
				                topLeft: 10,
				                topRight: 10,
				                bottomLeft: 0,
				                bottomRight: 0
				            }
					      }]
						},
						options: {
							responsive: true,
							maintainAspectRatio: false,
						    plugins: {
						        datalabels: {
						          color: 'white',
						          font: {
						            weight: 'bold'
						          }
						        }
						    },
						    scales: {
						        x: {
						          grid: {
						            display: false,
						          },
						          border: {
						            display: true,
						            width: 1,
						            color: 'white',
						            side: 'bottom'
						          },
						          ticks: {
						            display: true,
						            color: 'white',
						            font: {
						              weight: 'bold'
						            }
						          }
						        },
						        y: {
						          display: false
						        }
						    }
						}
					}),
					// @ts-ignore
					chart_right: new Chart(document.getElementById("chart-right"), {
						type: 'bar',
						data: {
						  labels: this.state.chart_right_labels || [],
						  datasets: this.state.chart_right_data.map((item: any, index: number) => {
						  	let color = '';

						  	switch (index) {
						  		case 0:
						  			color = Colors.range1;
						  		break;

						  		case 1:
						  			color = Colors.range2;
						  		break;

						  		case 2:
						  			color = Colors.range3;
						  		break;

						  		case 3:
						  			color = Colors.range4;
						  		break;
						  	}

						  	return {
						  		label: 'Conversaciones',
						        data: item || [],
						        borderColor: color,
						        backgroundColor: color,
						  	}
					      })
						},
						options: {
							responsive: true,
							maintainAspectRatio: false,
							plugins: {
						        datalabels: {
						          display: false
						        }
						    },
							scales: {
					            x: {
					            	grid: {
							            color: '#3f3f3f'
							        },
					                stacked: true,
					                ticks: {
							            display: true,
							            color: 'white',
							            font: {
							              weight: 'bold'
							            }
							        }
					            },
					            y: {
					            	grid: {
							            color: '#3f3f3f'
							        },
					                stacked: true,
					                ticks: {
							            display: true,
							            color: 'white',
							            font: {
							              weight: 'bold'
							            }
							        }
					            }
					        }
						}
					})
				});
			}
			catch(e) {
				console.log(e);
			}
		});
	}

	pay = () => {
		this.setState({
			visible_modal: true
		});
	}

	onClosePay = () => {
		this.setState({
			visible_modal: false
		},() => this.load(true));
	}
	
	render() {
		const { loading, visible_modal } = this.state;
		const plan_users: any = this.state.plan_users;

		return (
			<div id="home">
				<Modal
		          className="modal-view-plans"
		          visible={ visible_modal }
		          // title={ this.state.plan_users?.length > 0 ? 'Contratar plan' : 'Pagar plan' }
		          title="Planes"
		          onClose={ () => this.onClosePay() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalSelectPlan
		            onClose={ () => this.onClosePay() } />
		      	</Modal>

				{
					!loading && plan_users.length == 0 && (
						<div className="container-white">
							<h3>¡Empieza ahora a disfrutar de { process.env.REACT_APP_NAME }!</h3>
							<img src={ NoPlanImage } className="no-plan-image" />
							<button className="btn btn-pay" onClick={ () => this.pay() }>
								Ver planes
							</button>
						</div>
					)
				}
				{
					!loading && plan_users.length > 0 && (
						<div className="row">
							<div className="col-md-6">
								<div className="row">
									<div className="col-md-6">
										<div className="container-black">
											<h3>Conversaciones atendidas</h3>
											<div className="container-circle">
												<p>Total</p>
												<h1>{ this.state.total_conversations }</h1>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="container-gray">
											<h3>Canales conectados</h3>
											{
												this.state.ways?.sort((a: any, b: any) => b.quantity - a.quantity).map((item: any) => {
													return (
														<div className="item-social">
															<div>
																<div className="container-icon-social" style={{ backgroundColor: item.backgroundColor }}>
																	<img src={ item.icon } />
																</div>
															</div>
															<div style={{ width: '100%' }}>
																<p className="quantity">{ item.quantity }</p>
																<div className="bar-social-container">
																	<div className="bar-social" style={{ width: ((item.quantity / this.state.total_conversations) * 100) + '%', backgroundColor: item.barColor || item.backgroundColor }}></div>
																</div>
															</div>
														</div>
													)
												})
											}
											{
												this.state.ways?.sort((a: any, b: any) => b.quantity - a.quantity).length == 0 && (
													<p className="no-ways">No hay canales conectados</p>
												)
											}
											<div className="text-right">
												<button className="btn btn-link" onClick={ () => this.props.history.replace('/client/api') }>
													<img src={ MenuIcons.Menu4 } className="icon-link" />
													Conectar
												</button>
											</div>
										</div>
									</div>
									<div className="col-md-12">
										<div className="container-gray">
											<h3>Número de mensajes totales</h3>
											<div className="container-chart-left">
												<canvas id="chart-left"></canvas>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<div className="container-blue">
									<h3>Suscripción</h3>
									<div className="container-plan">
										<div>
											<div className="container-plan-icon">
												<img src={ MessageIcon } />
											</div>
										</div>
										<div>
											<h4>Plan</h4>
											{/*
											// @ts-ignore */}
											<h1>{ this.state.plan_users[0]?.plan?.name }</h1>
										</div>
										<div style={{ flex: 1 }}>
											<div className="container-use">
												<div className="row">
													<div className="col-6">
														<p>Consumidos</p>
													</div>
													<div className="col-6">
														<p className="text-right">{ this.state.uses_consultations } / { this.state.max_consultations }</p>
													</div>
												</div>
												<div className="container-bar-use">
													<div className="bar-use" style={{ width: ((this.state.uses_consultations / this.state.max_consultations) * 100) + '%' }}></div>
												</div>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-6">
											<button className="btn btn-pay" onClick={ () => this.pay() }>
												Ver Planes
											</button>
										</div>
									</div>
								</div>
								<div className="container-gray">
									<h3>Distribución por horarios/días con más actividad</h3>
									<div className="container-legend">
										<div className="container-time">
											<div className="container-icon">
												<img src={ TimeIcon } />
											</div>
											<p>Franja horaria</p>
										</div>
										<div className="row">
											<div className="col-md-3">
												<div className="legend">
													<div className="legend-circle" style={{ backgroundColor: Colors.range1 }}></div>
													<p>00-06</p>
												</div>
											</div>
											<div className="col-md-3">
												<div className="legend">
													<div className="legend-circle" style={{ backgroundColor: Colors.range2 }}></div>
													<p>06-12</p>
												</div>
											</div>
											<div className="col-md-3">
												<div className="legend">
													<div className="legend-circle" style={{ backgroundColor: Colors.range3 }}></div>
													<p>12-18</p>
												</div>
											</div>
											<div className="col-md-3">
												<div className="legend">
													<div className="legend-circle" style={{ backgroundColor: Colors.range4 }}></div>
													<p>18-12</p>
												</div>
											</div>
										</div>
									</div>
									<div className="container-chart-right">
										<canvas id="chart-right"></canvas>
									</div>
								</div>
							</div>
						</div>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Home);